import { IonCol, IonGrid, IonInfiniteScroll, IonInfiniteScrollContent, IonRow } from "@ionic/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { incrementPage } from "../../../store/documentsSignerList";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { selectFindStatus } from "../../../store/documentsSignerList/selectors/selectFindStatus";
import { selectSignerDocuments } from "../../../store/documentsSignerList/selectors/selectSignerDocuments";
import { selectViewMode } from "../../../store/documentsSignerList/selectors/selectViewMode";
import { DocumentCardItemList } from "./DocumentCardItemList";
import { DocumentItemList } from "./DocumentItemList";
import { DocumentSectionListLoading } from "./DocumentSectionListLoading";
export const DocumentsListSection: React.FC = () => {
  const dispatch = useDispatch();

  const documents = useSelector(selectSignerDocuments);
  const viewMode = useSelector(selectViewMode);

  const [infiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
  const findStatus = useSelector(selectFindStatus);
  const loadData = (ev: any) => {
    setTimeout(() => {
      dispatch(incrementPage());
      dispatch(fetchDocuments());

      ev.target.complete();
      if (documents.length % 30 !== 0) {
        setInfiniteDisabled(true);
      }
    }, 500);
  };

  return (
    <section>
      {findStatus === "fulfilled" && documents.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          No se han encontrado resultados
        </p>
      )}

      {viewMode === "list" ? (
        <section className="ion-padding-horizontal ion-margin-top">
          {documents.filter((document) => document?.status?.id == 2 || document?.status?.id == 3 || document?.status?.id == 7).map((document, index: number) => (
            <DocumentItemList document={document} key={index} />
          ))}
        </section>
      ) : (
        <IonGrid>
          <IonRow>
            {documents.filter((document) => document?.status?.id == 2 || document?.status?.id == 3 || document?.status?.id == 7).map((document, index: number) => (
              <IonCol size="12" sizeMd="6" sizeLg="4" key={index}>
                <DocumentCardItemList document={document} />
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      )}

      {!documents.length && findStatus === "pending" && <DocumentSectionListLoading />}

      <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={infiniteDisabled}>
        <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Loading more data..." />
      </IonInfiniteScroll>
    </section>
  );
};
